import { useRootSelector } from "./useAppSelector";
export const useHeadlessMode = () => {
    const { appSettings } = useRootSelector();
    const logged = appSettings?.StaticData?.HeadlessMode;
    const headlessMode = appSettings?.StaticData?.HeadlessModeEnabled;
    return {
        enabled: headlessMode,
        logged,
        hidePatientHeader: appSettings?.StaticData?.HeadlessModeHidePatientHeader,
        hideChartTabs: appSettings?.StaticData?.HeadlessModeHideChartTabs,
    };
};
